import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import store from 'frontend/_stores'
import { ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export class StagingAreasService extends ResourceService {
  constructor({
    eventSlug = setupRouter.currentRoute.value.params.eventSlug,
    baseUrl = `/events/${eventSlug}/staging_areas`,
    blocker,
    fetchError = 'Failed to fetch staging areas.',
    saveError = 'Failed to save staging area.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey: 'stagingAreas',
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      fetchError,
      saveError,
    })
    this.selectService = selectService
  }

  getForSelect() {
    return (additionalPayload = {}) =>
      this.selectService.fetchOptions({
        additionalPayload,
        fields: [
          'id',
          'time_zone',
          'name',
          { location: ['id', 'name', 'time_zone'] },
          { cluster: ['id', 'name'] },
        ],
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }

  dispatchAction(action, id, { url = `${this.baseUrl}${id ? '/' + id : ''}/${action}` } = {}) {
    const errorHandler = error => {
      const messagePayload = { message: 'Requested action cannot be run' }
      messagePayload.message = error.response?.data?.message || messagePayload.message
      if (error.response?.status == 422 && error.response?.data?.errors?.base?.length) {
        messagePayload.title = messagePayload.message
        messagePayload.message =
          error.response.data.errors.base.constructor == Array
            ? error.response.data.errors.base.join('; ')
            : error.response.data.errors.base
      }
      store.dispatch('toast/error', messagePayload)
    }
    return this._makeCall('post', errorHandler, { url })
  }
}
